import {Trans} from '@lingui/macro';
import React from 'react';

import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {VirtualTableColumnCellsEnum} from '../../../../components/common/table/helpers/tableHelpers';
import {TableColumn} from '../../../../components/common/table/tableColumn';

/*
 * Constants.
 */

export const developersApplicationTableNameColumnId = 'developers-app-table-name';
export const developersApplicationTableStatusColumnId = 'developers-app-table-status';
export const developersApplicationTableCreatorColumnId = 'developers-app-table-creator';
export const developersApplicationTableDateCreatedColumnId = 'developers-app-table-date-created';

export enum DevelopersApplicationTableColumnsEnum {
  NAME = 'name',
  STATUS = 'status',
  CREATOR = 'creator',
  CREATED_DATE = 'created_date',
}

export const developersApplicationTableColumns: ReadonlyArray<
  TableColumn<DevelopersApplicationTableColumnsEnum>
> = [
  {
    id: developersApplicationTableNameColumnId,
    title: <Trans id="developers-applications-table-column-name">Name</Trans>,
    type: DevelopersApplicationTableColumnsEnum.NAME,
    cellType: VirtualTableColumnCellsEnum.AVATAR,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: 0,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
        minWidth: 350,
        maxWidth: 350,
      },
      loading: {
        avatarSize: VisualSizesEnum.LARGE,
      },
    },
  },
  {
    id: developersApplicationTableStatusColumnId,
    title: <Trans id="developers-applications-table-column-status">Status</Trans>,
    type: DevelopersApplicationTableColumnsEnum.STATUS,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        minWidth: 152,
        maxWidth: 152,
      },
    },
  },
  {
    id: developersApplicationTableCreatorColumnId,
    title: <Trans id="developers-applications-table-column-creator">Creator</Trans>,
    type: DevelopersApplicationTableColumnsEnum.CREATOR,
    cellType: VirtualTableColumnCellsEnum.TEAMMATE,
    settings: {
      cellWidth: {
        minWidth: 152,
        maxWidth: 152,
      },
    },
  },
  {
    id: developersApplicationTableDateCreatedColumnId,
    title: <Trans id="developers-applications-table-column-created-date">Date created</Trans>,
    type: DevelopersApplicationTableColumnsEnum.CREATED_DATE,
    cellType: VirtualTableColumnCellsEnum.DATE,
    settings: {
      cellWidth: {
        minWidth: 152,
        maxWidth: 152,
      },
    },
  },
];
